import { getApis } from '../../library/Apis';
import api from '../../services/api';
import { toRequest } from '../../utils/RequestUtils';
import moment from 'moment';

export const LOADING_AGENDA_ASSESSORES_PEDAGOGICOS_DATA_ATUAL_ACTION =
  'LOADING_AGENDA_ASSESSORES_PEDAGOGICOS_DATA_ATUAL_ACTION';
export const LOADED_AGENDA_ASSESSORES_PEDAGOGICOS_DATA_ATUAL_ACTION =
  'LOADED_AGENDA_ASSESSORES_PEDAGOGICOS_DATA_ATUAL_ACTION';

export const LOADING_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION =
  'LOADING_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION';
export const LOADED_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION =
  'LOADED_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION';

export const CLEARED_AGENDA_ASSESSORES_PEDAGOGICOS_EDITING_VALUE_ACTION =
  'CLEARED_AGENDA_ASSESSORES_PEDAGOGICOS_EDITING_VALUE_ACTION';
export const CHANGED_AGENDA_ASSESSORES_PEDAGOGICOS_EDITING_VALUE_ACTION =
  'CHANGED_AGENDA_ASSESSORES_PEDAGOGICOS_EDITING_VALUE_ACTION';

export const LOADING_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION =
  'LOADING_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION';
export const LOADED_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION =
  'LOADED_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION';

export const LOADED_DASHBOARD_ACTION = 'LOADED_DASHBOARD_ACTION';

export const SAVING_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION =
  'SAVING_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION';

export const LOADING_DASHBOARD_ACTION = 'LOADING_DASHBOARD_ACTION';

const getEndpoint = () => {
  return getApis().apis.assessoria + 'v1/assessoria/';
};

export const clearAgendaAssessoresPedagogicosEditing = () => ({
  type: CLEARED_AGENDA_ASSESSORES_PEDAGOGICOS_EDITING_VALUE_ACTION,
  payload: null,
});

export const changeAgendaAssessoresPedagogicosEditingValue = (name, value) => {
  return (dispatch) => {
    if (typeof value === 'string') {
      if (value.trim().length > 0) {
        return new Promise((resolve) => {
          dispatch({
            type: CHANGED_AGENDA_ASSESSORES_PEDAGOGICOS_EDITING_VALUE_ACTION,
            payload: { name, value },
          });
          resolve();
        });
      } else {
        return new Promise((resolve) => {
          dispatch({
            type: CHANGED_AGENDA_ASSESSORES_PEDAGOGICOS_EDITING_VALUE_ACTION,
            payload: { name, value: '' },
          });
          resolve();
        });
      }
    }
    return new Promise((resolve) => {
      dispatch({
        type: CHANGED_AGENDA_ASSESSORES_PEDAGOGICOS_EDITING_VALUE_ACTION,
        payload: { name, value },
      });
      resolve();
    });
  };
};

export const loadAgendaAssessoresPedagogicosDataAtual = (
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_AGENDA_ASSESSORES_PEDAGOGICOS_DATA_ATUAL_ACTION,
      payload: true,
    });
    toRequest(
      api.get,
      [getEndpoint() + 'dataatual'],
      'agenda-assessores-pedagogicos-data-atual'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_AGENDA_ASSESSORES_PEDAGOGICOS_DATA_ATUAL_ACTION,
          payload: resp.data.dataAtual,
        });
        dispatch({
          type: LOADING_AGENDA_ASSESSORES_PEDAGOGICOS_DATA_ATUAL_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_AGENDA_ASSESSORES_PEDAGOGICOS_DATA_ATUAL_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadAgendaAssessoresPedagogicos = (
  codCoop,
  cpfAssessores,
  periodo,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION,
      payload: true,
    });
    toRequest(
      api.post,
      [
        getEndpoint() + 'lista',
        {
          codCoop,
          cpfAssessores,
          periodo,
        },
      ],
      'agenda-assessores-pedagogicos'
    ).then(
      (resp) => {
        const eventos = resp.data.eventos.map((evento) => {
          const horaInicial = moment(evento.horaInicial, 'HH:mm').format(
            'HH:mm'
          );
          const horaFinal = moment(evento.horaFinal, 'HH:mm').format('HH:mm');
          return {
            title: evento.assunto,
            horaInicial: horaInicial,
            horaFinal: horaFinal,
            start: new Date(
              moment(evento.data + ' ' + horaInicial, 'DD/MM/YYYY HH:mm')
            ),
            end: new Date(
              moment(evento.data + ' ' + evento.horaFinal, 'DD/MM/YYYY HH:mm')
            ),
            allDay: false,
            status: evento.status,
            id: evento.id,
            resource: evento.id,
            assessor: evento.assessor,
          };
        });
        dispatch({
          type: LOADED_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION,
          payload: eventos,
        });
        dispatch({
          type: LOADED_AGENDA_ASSESSORES_PEDAGOGICOS_DATA_ATUAL_ACTION,
          payload: resp.data.dataAtual,
        });
        dispatch({
          type: LOADING_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadEventoAgendaAssessoresPedagogicos = (
  id,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION,
      payload: true,
    });
    toRequest(
      api.get,
      [getEndpoint() + id],
      'evento-agenda-assessores-pedagogicos'
    ).then(
      (resp) => {
        const evento = {
          ...resp.data,
          tipoAgenda: resp.data.tipo,
          horaInicial: moment(resp.data.horaInicial, 'HH:mm').format('HH:mm'),
          horaFinal: moment(resp.data.horaFinal, 'HH:mm').format('HH:mm'),
        };
        dispatch({
          type: LOADED_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION,
          payload: evento,
        });
        dispatch({
          type: LOADING_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const deleteEventoAgendaAssessoresPedagogicos = (
  id,
  callbackSuccess,
  callbackError
) => {
  return () => {
    toRequest(api.delete, [getEndpoint() + id], 'save').then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const approveEventoAgendaAssessoresPedagogicos = (
  id,
  callbackSuccess,
  callbackError
) => {
  return () => {
    toRequest(api.put, [getEndpoint() + 'aprovar/' + id], 'save').then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const registerEventoAgendaAssessoresPedagogicos = (
  evento,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: SAVING_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION,
      payload: true,
    });
    toRequest(api.post, [getEndpoint() + 'cadastro', evento], 'save').then(
      (resp) => {
        dispatch({
          type: SAVING_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: SAVING_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const editEventoAgendaAssessoresPedagogicos = (
  evento,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: SAVING_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION,
      payload: true,
    });
    toRequest(api.put, [getEndpoint() + evento.id, evento], 'save').then(
      (resp) => {
        dispatch({
          type: SAVING_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: SAVING_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const generateDashboard = (filtros, callbackSuccess, callbackError) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_DASHBOARD_ACTION,
      payload: true,
    });
    toRequest(
      api.post,
      [getEndpoint() + 'dashboard', filtros],
      'dashboard-agenda-assessores'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_DASHBOARD_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_DASHBOARD_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_DASHBOARD_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};
